import { useQuery } from '@tanstack/react-query';
import { getInvoiceTaxAuthorityConfigByContactId } from 'Services/invoices';

export default function useContactTaxAuthorityConfig(contactId) {
    return useQuery({
        queryKey: ['invoice-tax-authority-config', contactId],
        queryFn: () => getInvoiceTaxAuthorityConfigByContactId(contactId),
        enabled: !!contactId,
        placeholderData: null,
    });
}
